/** Insurance subpackage messages — English */
export default {
  insurance: {
    nav: {
      home: 'Insurance',
      detail: 'Policy details',
    },
    common: {
      orderNo: 'Order No.: {id}',
      total: 'Total ￥{amount}',
      countUnit: '{count} policy/policies',
      detail: 'Details',
      actualPaid: 'Paid',
      actualRefund: 'Refund amount',
      estimatedRefundPoints: 'Extra pts',
      unionPointCount: '{count} pts',
      priceMultiply: '￥{price} ×{count}',
      applyTime: 'Applied: {time}',
      policyTab: 'Policy {index}',
      policyNo: 'Policy No.',
      flightRange: 'Covered route',
      insurer: 'Insurer',
      insuType: 'Insurance type',
      policySummary: '{name}: {insuranceName} (Policy: {route})',
    },
    tip: {
      invoice: 'After departure you can issue an insurance invoice here or together with your flight order.',
    },
    btn: {
      refundHistory: 'Refund history',
      applyRefund: 'Request refund',
      invoice: 'Invoice / receipt',
      invoiceDetail: 'Invoice details',
      confirmRefund: 'Confirm refund',
    },
    popup: {
      amountDetail: 'Order breakdown',
      applyRefund: 'Request refund',
      refundHistory: 'Refund history',
      invoiceDetail: 'Invoice details',
    },
    section: {
      coverage: 'Coverage',
      detail: 'Policy details',
      claim: 'How to claim',
    },
    claim: {
      delay: 'Call the service number in the policy details.',
      accident: 'Contact the insurer to file a claim.',
    },
    toast: {
      refundSuccess: 'Refund submitted',
      cannotRefund: 'This ticket is being changed. Insurance refund is temporarily unavailable. Please complete or cancel the change request before applying again.',
      insuringCannotRefund: 'Policy is being issued; refund unavailable',
    },
  },
}
